import React, { useMemo, useRef } from 'react';
import useOnViewport from 'src/hooks/useOnViewport';
import PoliciesLinksList from 'src/molecules/Shared/2023_Q4/Footer/PoliciesLinksList';
import { getSectionScaleValueByWindowWidth } from 'src/styles/functions/getAnimationContainerDefaultStyles';
import useWindowResize from 'src/hooks/useWindowResize';
import {
  FooterContainer,
  FooterGridContainer,
  FooterGridWrapper,
  BottomBlock,
  PoliciesLinkWrapper,
  LogoContainer,
} from './Footer.styles';
import FooterTopGrid from 'src/molecules/Shared/2023_Q4/Footer/FooterTopGrid';
import FooterBottomGrid from 'src/molecules/Shared/2023_Q4/Footer/FooterBottomGrid';
import LogoLink from 'src/molecules/Shared/2023_Q4/Footer/LogoLink';
import { LinkProps } from 'src/elements/links/2023_Q4/LinkBranded';
import { LayoutTheme } from 'src/elements/Layout/2023_Q4/Layout';

interface FooterProps {
  isFullScreen?: boolean;
  formCallToActionColorScheme?: LinkProps['colorScheme'];
  isLogoClickable?: boolean;
  theme?: LayoutTheme;
}

const Footer = ({
  isFullScreen,
  formCallToActionColorScheme,
  isLogoClickable = true,
  theme,
}: FooterProps): JSX.Element => {
  const bottomContainerRef = useRef<HTMLDivElement>(null);

  const { width: windowWidth, height: windowHeight } = useWindowResize();

  const contentScale = useMemo(() => {
    if (!isFullScreen) return 1;

    return getSectionScaleValueByWindowWidth(windowWidth, windowHeight);
  }, [isFullScreen, windowWidth, windowHeight]);

  const isVisible = useOnViewport(bottomContainerRef, 0.5);

  return (
    <FooterContainer
      isFullScreen={isFullScreen}
      id='footer'
    >
      <FooterGridContainer>
        <FooterGridWrapper currentScale={contentScale}>
          <FooterTopGrid
            colorScheme={formCallToActionColorScheme}
            theme={theme}
          />
          {/* Hide Bottom Grid on mobile, and move the icons to the TopGrid containers */}
          <FooterBottomGrid />
        </FooterGridWrapper>
      </FooterGridContainer>
      <BottomBlock ref={bottomContainerRef}>
        <LogoContainer currentScale={contentScale}>
          <LogoLink
            clickable={isLogoClickable}
            color='white'
            isVisible={isVisible}
          />
        </LogoContainer>
        <PoliciesLinkWrapper currentScale={contentScale}>
          <PoliciesLinksList />
        </PoliciesLinkWrapper>
      </BottomBlock>
    </FooterContainer>
  );
};

export default Footer;
